module.exports = __webpack_public_path__ + "assets/img/btn-view-mecha-info-07049788.png";